import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-wrapper1',
  templateUrl: './info-wrapper1.component.html',
  styleUrls: ['./info-wrapper1.component.scss']
})
export class InfoWrapper1Component implements OnInit {

  @Input() infpWrapper1Type:string;

  constructor() { }

  ngOnInit(): void {
  }

}
